import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import {
  fetchConversationListing,
  fetchUserListing,
  setSelectedConversationId,
} from 'src/redux/chatbotConversations'
import ConversationTable from './ConversationTable'
import ConversationThreadPanel from './ConversationThreadPanel'
import UserTable from './UserTable'
import UserConversationList from './UserConversationList'

const TAB_BY_CONVERSATION = 0
const TAB_BY_USER = 1

const ChatbotConversations = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { selectedUserId } = useSelector(state => state.chatbotConversations)

  const [activeTab, setActiveTab] = useState(TAB_BY_CONVERSATION)
  const [userTabLoaded, setUserTabLoaded] = useState(false)

  useEffect(() => {
    dispatch(fetchConversationListing({}))
  }, [dispatch])

  const handleTabChange = (_event, newValue) => {
    setActiveTab(newValue)
    dispatch(setSelectedConversationId(null))

    if (newValue === TAB_BY_USER && !userTabLoaded) {
      dispatch(fetchUserListing({}))
      setUserTabLoaded(true)
    }
  }

  const leftPanelContent =
    activeTab === TAB_BY_CONVERSATION ? (
      <ConversationTable />
    ) : selectedUserId ? (
      <UserConversationList />
    ) : (
      <UserTable />
    )

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant='h4' gutterBottom>
        Chatbot Conversations
      </Typography>

      <Paper
        variant='outlined'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 180px)',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ borderBottom: `1px solid ${theme.palette.grey[200]}`, flexShrink: 0 }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label='By Conversation' />
            <Tab label='By User' />
          </Tabs>
        </Box>

        <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <Box
            sx={{
              width: '40%',
              borderRight: `1px solid ${theme.palette.grey[200]}`,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            {leftPanelContent}
          </Box>

          <Box sx={{ width: '60%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <ConversationThreadPanel />
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

export default ChatbotConversations
